import React, { useState } from "react";
import "./Header.css";

import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import ListItemText from "@material-ui/core/ListItemText";
import DraftsIcon from "@material-ui/icons/Drafts";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import { auth } from "./firebase";

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #06202A",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:focus": {
      backgroundColor: theme.palette.primary.main,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

const Header = ({ user }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showLinks, setShowLinks] = useState(false);
  const history = useHistory();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className='sticky top-0'>
      {showLinks && (
        <div
          className={`${
            !showLinks ? "hide" : "show"
          } flex justify-center items-center bg-white text-color`}>
          <div className='grid grid-cols-2 gap-x-24 gap-y-1 place-items-center place-content-center'>
            <div className='cursor-pointer object-contain w-24'>
              <Link to='/' className='text-decoration-none'>
                <img
                  onClick={() => setShowLinks(false)}
                  className='p-2'
                  src='/images/payda.jfif'
                  alt=''
                />
              </Link>
            </div>
            <div className='flex flex-col capitalize  md:hidden items-center'>
              <Link to='/about' className='text-decoration-none'>
                <h6
                  onClick={() => setShowLinks(false)}
                  className='text-color font-bold mt-2'>
                  About
                </h6>
              </Link>
            </div>
            <div>
              <Link className='text-decoration-none' to='/create'>
                <h6
                  onClick={() => setShowLinks(false)}
                  className='text-color font-bold'>
                  Add Post
                </h6>
              </Link>
            </div>
            <div
              className='text-color rounded-md mb-2'
              onClick={() => setShowLinks(false)}>
              {!user ? (
                <Button
                  className='capitalize btn'
                  onClick={() => history.push("/signUp")}>
                  Sign Up
                </Button>
              ) : (
                <Button
                  className='capitalize btn '
                  onClick={() => auth.signOut()}>
                  Logout
                </Button>
              )}
            </div>
          </div>
          <div className='md:hidden absolute top-3 right-3'>
            {showLinks ? (
              <CloseIcon
                className='close'
                onClick={() => setShowLinks(!showLinks)}
              />
            ) : (
              <MenuIcon onClick={() => setShowLinks(!showLinks)} />
            )}
          </div>
        </div>
      )}

      <div
        className={`${
          showLinks && "hidden"
        } bg-white flex justify-between  content-center border-b-6 border-color shadow-2xl items-center z-40 top-0 sticky py-2`}>
        <div className=' flex items-center justify-between px-7 w-full'>
          <div className='cursor-pointer object-contain md:w-2/12 xs:w-6/12 md:ml-12 xs:m-0 p-2'>
            <Link to='/' className='text-decoration-none'>
              <img className='w-24' src='/images/payda.jfif' alt='' />
            </Link>
          </div>
          <div className='md:hidden'>
            <MenuIcon onClick={() => setShowLinks(!showLinks)} />
          </div>

          <div className='flex xs:flex-col md:flex-row justify-between capitalize px-3 w-5/12 xs:hidden md:flex items-center'>
            <Link to='/about' className='text-decoration-none'>
              <h6 className='text-color font-bold'>About</h6>
            </Link>

            <Link className='text-decoration-none' to='/create'>
              <h6 className='text-color font-bold'>Add Post</h6>
            </Link>
            <div className='text-color rounded-md'>
              {!user ? (
                <Button
                  className='capitalize btn'
                  aria-controls='customized-menu'
                  aria-haspopup='true'
                  variant='outlined'
                  onClick={handleClick}>
                  Sign Up
                </Button>
              ) : (
                <Button
                  className='capitalize btn '
                  aria-controls='customized-menu'
                  aria-haspopup='true'
                  variant='outlined'
                  onClick={() => auth.signOut()}>
                  Logout
                </Button>
              )}
              <StyledMenu
                id='customized-menu'
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}>
                <StyledMenuItem onClick={() => history.push("/signup")}>
                  <ListItemIcon>
                    <PermIdentityIcon fontSize='small' />
                  </ListItemIcon>
                  <ListItemText primary='Sign Up' />
                </StyledMenuItem>
                <StyledMenuItem onClick={() => history.push("/signin")}>
                  <ListItemIcon>
                    <DraftsIcon fontSize='small' />
                  </ListItemIcon>
                  <ListItemText primary='Log In' />
                </StyledMenuItem>
              </StyledMenu>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
